import { Injectable, OnInit, Output, EventEmitter } from '@angular/core';
import { CLEANER_AVAILABILITY } from './mock-users';
import { Http, Response, Headers, URLSearchParams, Jsonp} from '@angular/http';
import { Subject, Subscription } from 'rxjs/Rx';
import {AuthService} from "./auth.service";
import {LoaderService} from "../common/loadingBar/loader.service";
import { Router } from "@angular/router";
import * as moment from 'moment';


@Injectable()
export class ExportsService extends AuthService{

    private URLExportUsers = "manager/exports/clients?date_min=:dateIni&date_max=:dateEnd";
    private URLExportUserVal = "manager/exports/user-valuation?date_min=:dateIni&date_max=:dateEnd";
    private URLExportServices = "manager/exports/services?date_min=:dateIni&date_max=:dateEnd";
    private URLExportBookings = "manager/exports/booking?date_min=:dateIni&date_max=:dateEnd";
    private URLExportCleanerVal = "manager/exports/cleaner-valuation?date_min=:dateIni&date_max=:dateEnd";
    private URLExportCancellations = "manager/exports/cancellations?date_min=:dateIni&date_max=:dateEnd";
    private URLExportLeads = "manager/exports/leeds?date_min=:dateIni&date_max=:dateEnd";
    private URLExportCleanersRanking = "manager/exports/cleaners-ranking?date_min=:dateIni&date_max=:dateEnd";
    private ACTIVE = ":active";
    private DATEI = ":dateIni";
    private DATEE = ":dateEnd";
    constructor(public http: Http, public router: Router, private loaderService: LoaderService) {
        super(http,router);
    }
  
    public exportUsers(dateIni: string, dateEnd: string) {
        let URLExportUsers = this.URLExportUsers.replace(this.DATEI, dateIni).replace(this.DATEE, dateEnd);
        return this.http.get(this.APIURL + URLExportUsers ,{ headers: this.headers})
        .map((res: Response) => res["url"] + "&access_token=" + this.headers.get("X-Access-Token"));
    }

    public exportUserValuations(dateIni: string, dateEnd: string) {
        let URLExportUserVal = this.URLExportUserVal.replace(this.DATEI, dateIni).replace(this.DATEE, dateEnd);
        return this.http.get(this.APIURL + URLExportUserVal, { headers: this.headers })
        .map((res: Response) => res["url"] + "&access_token=" + this.headers.get("X-Access-Token"));
    }

    public exportCleanerValuations(dateIni: string, dateEnd: string){
        let URLExportCleanerVal = this.URLExportCleanerVal.replace(this.DATEI, dateIni).replace(this.DATEE, dateEnd);
        return this.http.get(this.APIURL + URLExportCleanerVal ,{ headers: this.headers})
        .map((res: Response) => res["url"] + "&access_token=" + this.headers.get("X-Access-Token"));
    }

    public exportBookings(dateIni: string, dateEnd: string) {
        let URLExportBookings = this.URLExportBookings.replace(this.DATEI, dateIni).replace(this.DATEE, dateEnd);
        return this.http.get(this.APIURL + URLExportBookings ,{ headers: this.headers})
        .map((res: Response) => res["url"] + "&access_token=" + this.headers.get("X-Access-Token"));
    }

    public exportByCancellations(dateIni: string, dateEnd: string) {
        let URLExportCancellations = this.URLExportCancellations.replace(this.DATEI, dateIni).replace(this.DATEE, dateEnd);
        return this.http.get(this.APIURL + URLExportCancellations ,{ headers: this.headers})
        .map((res: Response) => res["url"] + "&access_token=" + this.headers.get("X-Access-Token"));
    }

    public exportServices(dateIni: string, dateEnd: string) {
        let URLExportServices = this.URLExportServices.replace(this.DATEI, dateIni).replace(this.DATEE, dateEnd);
        return this.http.get(this.APIURL + URLExportServices, { headers: this.headers })
        .map((res: Response) => res["url"] + "&access_token=" + this.headers.get("X-Access-Token"));
        
    }

    public exportLeads(dateIni: string, dateEnd: string) {
        let URLExportLeads = this.URLExportLeads.replace(this.DATEI, dateIni).replace(this.DATEE, dateEnd);
        return this.http.get(this.APIURL + URLExportLeads, { headers: this.headers })
        .map((res: Response) => res["url"] + "&access_token=" + this.headers.get("X-Access-Token"));
    }

    public exportCleanerRanking(dateIni: string, dateEnd: string) {
        let URLExportCleanersRanking = this.URLExportCleanersRanking.replace(this.DATEI, dateIni).replace(this.DATEE, dateEnd);
        return this.http.get(this.APIURL + URLExportCleanersRanking, { headers: this.headers })
        .map((res: Response) => res["url"] + "&access_token=" + this.headers.get("X-Access-Token"))
    }

}


// WEBPACK FOOTER //
// ./src/app/injections/exports.service.ts